import styled from 'styled-components';

import { Color, FontWeight, ZIndex } from '../../enums';
import { StyledComponent } from '../../interfaces';
import { Icon } from '../icon/icon.component';
import { ValidationBar } from '../validationBar/validationBar.component';

import { CheckboxInputProps, CheckMarkProps, LabelProps } from './checkbox.types';

export const Wrapper: StyledComponent<'div'> = styled.div``;

export const Container: StyledComponent<'span'> = styled.span`
  width: fit-content;
  display: flex;
`;

export const StyledIcon: StyledComponent<typeof Icon> = styled(Icon)`
  opacity: 0;
  transform: 0.3s;
`;

export const CheckMark: StyledComponent<'span', CheckMarkProps> = styled.span<CheckMarkProps>`
  height: 16px;
  width: 16px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 12px;
  background-color: ${Color.White};
  border: 1px solid ${(props: CheckMarkProps) => props.$checked ? Color.Black : Color.Stroke};
  border: 1px solid ${(props: CheckMarkProps) => props.$invalid ? Color.Error500 : Color.Stroke};
  flex-shrink: 0;
  cursor: pointer;
`;

export const CheckboxInput: StyledComponent<'input', CheckboxInputProps> = styled.input<CheckboxInputProps>`
  opacity: 0;
  cursor: pointer;
  position: absolute;
  z-index: ${ZIndex.Min};
  border: 1px solid ${Color.Stroke};

  &[type="checkbox"] {
    width: 16px;
    height: 16px;
  }

  &:checked + ${CheckMark} {
    background-color: ${({ $color }: CheckboxInputProps): Color => $color || Color.Black};
    border: 1px solid ${({ $color }: CheckboxInputProps): Color => $color || Color.Black};

    ${StyledIcon} {
      opacity: 1;
    }
  }

  &:disabled + ${CheckMark} {
    background-color: ${Color.Gray300};
    border: 1px solid ${Color.Gray400};

    ${StyledIcon} {
      color: ${Color.Black};
    }
  }
`;

export const Label: StyledComponent<'label', LabelProps> = styled.label<LabelProps>`
  font-size: 12px;
  line-height: 16px;
  color: ${Color.Gray500};
  cursor: ${(props: LabelProps) => props.$disabled ? 'default' : 'pointer'};

  a {
    color: ${Color.Black};
    text-decoration: underline;
    font-weight: ${FontWeight.Bold};
  }
`;

export const StyledValidationBar: StyledComponent<typeof ValidationBar> = styled(ValidationBar)`
  margin-top: 12px;
`;
